import { Button, Card, CardActions, CardContent } from '@mui/material';
import { withRemoteDataAndSpinner } from 'hoc/withRemoteDataAndSpinner';
import withRouter from 'hoc/withRouter';
import { useLoadAll } from 'hooks/useLoadAll';
import { Link, useNavigate } from 'react-router-dom';
import customersService from 'services/admin/customersService';
import _ from 'lodash'
import { expiredInDays, toDate, toDocumentFormat, toFullDateName } from 'helpers/dateHelper';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import moment from 'moment';
import { phoneToUI } from 'hajjtravel-utils';
import CustomerOrders from 'components/CustomerOrders/CustomerOrders';
import { snack } from 'components/Snack/Snack';

const gender = {
    'F': 'Женщина',
    'M': 'Мужчина'
}

function Customer({ data: { customer } }) {
    const navigate = useNavigate()
    const onDelete = async (item) => {
        try {
            const isConfirmed = window.confirm('Вы точно хотите удалить клиента?')

            if (isConfirmed) {
                await customersService.delete(item.id);
                snack('Клиент успешно удален!')
                navigate('/admin/customers')
            }
        } catch (ex) {
            console.error('При удаление клиента вышла ошибка:', ex?.message)
            snack('При удаление клиента вышла ошибка:' + ex?.message)
        }
    };

    const passport = _.get(customer, 'passport')
    const IDCard = _.get(customer, 'IDCard')

    return (
        <div>
            <Card>
                <CardContent>
                    <div className='flex gap-8'>
                        <div>
                            <img style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '50%' }} src={customer.photo || `/media/images/avatar_m.jpg`} />
                        </div>
                        <div className='profile'>
                            <h3>{_.get(customer, 'lastName')} {_.get(customer, 'firstName')}</h3>
                            {customer.users?.phone && <div className='m-t-16 color-blue'>+7{phoneToUI(customer.user.phone)}</div>}
                            <div className='m-t-8'>{customer.user.email}</div>
                            <div className='m-t-8'>Номер телефона: {customer.user.phone}</div>
                            <div className='m-t-8'>Дата рождения: {customer.birthdate ? moment(customer.birthdate).format('DD.MM.YYYY') : 'Отсутсвует'}</div>
                            <div className='m-t-8'>Пол: {customer.gender ? gender[customer.gender] : customer.gender}</div>
                            <div className='m-t-8'>Гражданство: {_.get(customer, 'citizenship.name', 'Отсутсвует')}</div>                            
                            <div className='m-t-8'>Является клиентом с {toFullDateName(customer.createdAt)}</div>
                            <div className='m-t-16 fs-14'>Заметка: {_.get(customer, 'comment', '')}</div>
                        </div>
                    </div>
                </CardContent>
                <CardActions className='justify-end'>
                    <Link to={`/admin/customers/edit/${customer.id}`}>
                        <Button size="small">Редактировать</Button>
                    </Link>
                    <Link onClick={() => onDelete(customer)}>
                        <Button size="small">Удалить</Button>
                    </Link>
                </CardActions>
            </Card>    
            <CustomerOrders customerID={customer.id}></CustomerOrders>
        </div>
    )
}
export default withRouter(
    withRemoteDataAndSpinner(Customer, (router) => {
        return useLoadAll({
            customer: () => customersService.get(router.params.id),
        });
    })
);
